<template>
  <Evform
    ref="Evform"
    :loading="loading"
    :model="model"
    :urlSubmit="urlSubmit"
    :submitType="submitType"
    :btnDoReset="btnDoReset"
  >
    <el-col :span="24">
      <el-form-item label="敏感词" prop="word" :rules="this.validate.rules({required:true})">
        <el-input v-model.trim="model.word" placeholder="请输入敏感词"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12" v-if="openType != -1">
      <el-form-item label="添加人" prop="createUser" :rules="this.validate.rules({})">
        <el-input v-model.trim="model.createUser" :disabled="true"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12" v-if="openType != -1">
      <el-form-item label="创建时间" prop="createDate" :rules="this.validate.rules({})">
        <el-input v-model.trim="model.createDate" :disabled="true"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12" v-if="openType != -1">
      <el-form-item label="修改人" prop="updateUser" :rules="this.validate.rules({})">
        <el-input v-model.trim="model.updateUser" :disabled="true"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12" v-if="openType != -1">
      <el-form-item label="修改时间" prop="updateDate" :rules="this.validate.rules({})">
        <el-input v-model.trim="model.updateDate" :disabled="true"></el-input>
      </el-form-item>
    </el-col>
  </Evform>
</template>
<script>
export default {
  name: "templateForm",
  data() {
    return {
      loading: true,
      openType: "",
      //表单数据
      model: {
        id: this.openType,
        word: "", //敏感词
        createUser: "", //添加人
        createDate: "", //创建时间
        updateUser: "", //修改人
        updateDate: "" //修改时间
      }
    };
  },
  created() {
    this.loading = false;
    //-1为新增
    this.openType = this.$route.query.id ? this.$route.query.id : -1;
    this.addOrEdit();
  },
  computed: {
    //保存数据接口地址
    urlSubmit() {
      return this.openType == -1
        ? "/wtcp-support/sensitiveWords"
        : "/wtcp-support/sensitiveWords/" + this.openType;
    },
    // 请求类型
    submitType() {
      return this.openType == -1 ? "post" : "put";
    }
  },
  methods: {
    // 新增、编辑
    addOrEdit() {
      if (this.openType != -1) {
        this.request
          .getId("/wtcp-support/sensitiveWords/", this.openType)
          .then(res => {
            if (res.status === 1) {
              const data = res.data;
              for (let key in this.model) {
                if (!data[key]) {
                  this.model[key] = "";
                } else {
                  this.model[key] = data[key];
                }
              }
            }
          });
      }
    },
    //重置
    btnDoReset(e) {
      this.addOrEdit();
    }
  }
};
</script>
<style lang="less" scoped>
</style>

